import React from 'react';
import { connect } from 'react-redux';

// Components
import { Slider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import { SliderRail, Handle, Track, Tick } from "./Components.js"; 

// CSS
import './HorizontalInputSlider.css';

const sliderStyle = {
  position: "relative",
  width: "100%"
};

const domain = [0, 10];
// const defaultValues = [450, 400, 300, 150];
const defaultValues = [1];

class HorizontalInputSlider extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let changeEvent = this.props.collage.photos.numChosen > 20 ? 'onChange' : 'onUpdate';
    return (
      <div className="HorizontalInputSlider">
        <Slider
          mode={1}
          step={1}
          domain={domain}
          rootStyle={sliderStyle}
          {...{ [changeEvent]: this.props.onChange }}
          values={defaultValues}
        >
          <Rail>
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map((handle) => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
          <Ticks count={5}>
            {({ ticks }) => (
              <div className="slider-ticks">
                {ticks.map((tick) => (
                  <Tick key={tick.id} tick={tick} count={ticks.length} />
                ))}
              </div>
            )}
          </Ticks>
        </Slider>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  null
)(HorizontalInputSlider)

